import ArticleNumber from "../ArticleNumber/ArticleNumber";
import { Description } from "../Description/Description";
import { LabeledText } from "../LabeledText/LabeledText";

import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import {
  useTranslatedProductDescription,
  useTranslatedProductName,
} from "@4pace-cpq/core";
import { VMLineItems, VMSubItems } from "@4pace-cpq/core/api";
import Box from "@mui/material/Box";

export function BasicItemInfo({
  item,
}: {
  item: VMLineItems | VMSubItems;
}): JSX.Element {
  const { t } = useTranslation();
  const name = useTranslatedProductName(item);
  const description = useTranslatedProductDescription(item);

  return (
    <Box display="flex" gap={2}>
      <LabeledText
        label={t("CPQ:item.property.label.partId")}
        text={<ArticleNumber item={item} />}
      />

      <LabeledText
        sx={{ width: "300px" }}
        label={t("CPQ:item.property.label.name")}
        text={item.name ?? name ?? "-"}
      />

      {(item.description || description) && (
        <LabeledText
          label={t("CPQ:item.property.label.description")}
          text={<Description text={item.description ?? description} />}
        />
      )}
    </Box>
  );
}
